import { useAppStore } from "../../store";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { theme } from "antd";
import { jsx as _jsx } from "react/jsx-runtime";
var MenuFooter = function MenuFooter(props) {
  var menuCollapsed = useAppStore(function (s) {
    return s.menuCollapsed;
  });
  var setMenuCollapsed = useAppStore(function (s) {
    return s.setMenuCollapsed;
  });
  var themeInfo = theme.useToken();
  var token = themeInfo.token;
  if (props !== null && props !== void 0 && props.isMobile) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    onClick: function onClick() {
      return setMenuCollapsed(!menuCollapsed);
    },
    style: {
      padding: menuCollapsed ? "0 ".concat(token.padding, "px") : "0 ".concat(token.paddingMD, "px"),
      height: 40,
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      color: menuCollapsed ? token.colorPrimaryText : token.colorTextSecondary
    },
    children: menuCollapsed ? /*#__PURE__*/_jsx(MenuUnfoldOutlined, {}) : /*#__PURE__*/_jsx(MenuFoldOutlined, {})
  });
};
export default MenuFooter;